export default "__VITE_ASSET__C25Os6ms__"